import React, { useCallback, useMemo } from 'react';
import { useTheme } from 'styled-components';
import { Box, Button, Flex, Text, TextLink } from '../../ui-kit';
import { LOYALTY_IMAGES } from '../assets/images';
import { Icon } from '../assets/styles';
import { editCopyByReplaceWithMultipleComponent } from '../../utilities/copyFunctions';
import * as COPY from '../utilities/copy';
import withGlobalModal from '../../GlobalModal/withGlobalModal';
import { MODAL_KEYS } from '../../../utilities/constants';
import { FLOW_NAVIGATION_ACTIONS } from '../../../flows/DynamicFlow/utilities/constants';
import { useMediaQuery } from 'react-responsive';
import { pushEvent } from '../../../utilities/dataLayerUtils';

const LoyaltyJoinVoyagersMessage = ({
  openModal,
  triggerDynamicStepNavigation,
  clearSelectedPackages,
  clearSelectedSuite
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery({
    query: `(max-width: ${theme.breakpoints.md})`
  });

  const handleRestartSearch = useCallback(() => {
    pushEvent({
      event: 'custom_click',
      click_category: 'voyagers club',
      click_type: 'restart booking'
    });
    triggerDynamicStepNavigation(FLOW_NAVIGATION_ACTIONS.FLOW_TRIGGER_FIRST_STEP);
    clearSelectedPackages();
    clearSelectedSuite();
  }, [triggerDynamicStepNavigation, clearSelectedPackages, clearSelectedSuite]);

  const handleOpenJoinModal = useCallback(() => {
    openModal(
      {
        keyContentComponent: MODAL_KEYS.AUTH_MODAL,
        params: { shouldOpenSignUpWIthEmail: true, eventLocation: 'voyager payment page', showBackButton: false }
      },
      false,
      true
    );
  }, [openModal]);

  const desktopContent = useMemo(() => {
    const signInLink = (
      <TextLink color="voyagersMoonlight" onClick={handleOpenJoinModal}>
        {COPY.JOIN_VOYAGERS_MESSAGE_SIGNIN}
      </TextLink>
    );

    const restartLink = (
      <TextLink color="voyagersMoonlight" onClick={handleRestartSearch}>
        {COPY.JOIN_VOYAGERS_MESSAGE_RESTART}
      </TextLink>
    );

    const copyObject = {
      '<SIGN_IN>': signInLink,
      '<RESTART>': restartLink
    };

    return editCopyByReplaceWithMultipleComponent(COPY.JOIN_VOYAGERS_MESSAGE, copyObject);
  }, [handleOpenJoinModal, handleRestartSearch]);

  return (
    <Box mb={7} py={9} px={3} backgroundColor={theme.colors.deepForestGreen[100]} borderRadius="8px">
      <Flex gap="12px" alignItems="center">
        <Icon size="32px" src={LOYALTY_IMAGES.ADVENTURE_BUCK_COIN_GREEN} alt="Loyalty" />
        <Text color="voyagersMoonlight" lineHeight="150%" fontSize={[0, 0, 0, 1]} fontWeight="medium">
          {isMobile ? COPY.JOIN_VOYAGERS_MESSAGE_MOBILE : desktopContent}
        </Text>
      </Flex>
      {isMobile && (
        <Box mt={3}>
          <Button size="mobileMedium2025" fluid variant="primaryLoyalty2025" onClick={handleOpenJoinModal}>
            {COPY.JOIN_VOYAGERS_MESSAGE_FOR_FREE}
          </Button>

          <Box textAlign="center" mt={3}>
            <TextLink lineHeight="150%" fontSize={0} color="voyagersMoonlight" onClick={handleRestartSearch}>
              {COPY.JOIN_VOYAGERS_MESSAGE_RESTART_MOBILE}
            </TextLink>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default withGlobalModal(LoyaltyJoinVoyagersMessage);
